import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useRegistration} from '../hooks/useRegistration.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: registrationId} = useParams();

    if (typeof registrationId === 'undefined') {
        throw new Error('registrationId is required parameter');
    }

    const {
        record: registration,
        updateRecord,
        loading,
    } = useRegistration(registrationId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !registration) {
        return <PlatformLoader message='Loading registration...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={registration.productCode ? registration.productCode : registration.id}
            pageNavigation={<EditPageNavigation component={registration}/>}
            tools={tools}
        >

            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={registration}
                    />
                </Stack>
                :
                <RecordForm
                    record={registration}
                    handleSubmit={updateRecord}
                />}

        </FormPageLayout>
    );
};
